import DateInput from "./DateInput";
import { changeReturningDate, selectFormValidity } from "../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";

function ReturningDateInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const returningDate = useAppSelector(
    (state) => state.searchFlights.form.returningDate
  );
  const departingDate = useAppSelector(
    (state) => state.searchFlights.form.departingDate
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const roundTrip = useAppSelector(
    (state) => state.searchFlights.form.roundTrip
  );
  const { returningDateFilled, departingDateBeforeReturningDate } =
    useAppSelector(selectFormValidity);
  const startingDay = useAppSelector(
    (state) => state.config.components.Inputs.ReturnRequestDate.startingDay
  );

  const allowPastDates = useAppSelector(
    (state) => state.config.components.Inputs.ReturnRequestDate.pastDate ?? true
  );
  const minDate = departingDate
    ? new Date(departingDate)
    : allowPastDates
    ? null
    : new Date();

  return (
    <DateInput
      id="returning-date-input"
      title={t("RETURN_DATE_SEARCH_TITLE")}
      date={returningDate ? new Date(returningDate) : null}
      onDateSelect={(date) =>
        dispatch(changeReturningDate(date && date.getTime()))
      }
      inputLabel={t("RETURN_DATE")}
      disabled={disabled || !roundTrip}
      error={
        returningDateFilled
          ? departingDateBeforeReturningDate
            ? null
            : t("SEARCH_ALERT_RETURN_DATE")
          : t("SEARCH_ALERT_RETURN_DATE_REQUIRED")
      }
      startingDay={startingDay}
      minDate={minDate}
    />
  );
}

export default ReturningDateInput;
